export default "__VITE_ASSET__I4$HBhSb__"